export default "__VITE_ASSET__ylpQdmQ4__"